import moment from 'moment';

export const PAGE_CONTEXT_WAIT_MS = 3000;

export const getPageNavigationKey = ({ pathname, search = '' }) => `${pathname}${search}`;

const parseDate = (value) => {
    const date = moment.utc(value, ['YYMMDD', 'YYYY-MM-DD'], true);
    return date.isValid() ? date.format('YYYY-MM-DD') : undefined;
};

const positiveInteger = (value) => {
    const number = Number(value);
    return Number.isSafeInteger(number) && number > 0 ? number : undefined;
};

const parseUrlSearch = (query) => {
    const params = new URLSearchParams(query);
    const children = params.get('children_ages');
    return {
        check_in: parseDate(params.get('check_in')),
        check_out: parseDate(params.get('check_out')),
        guests: positiveInteger(params.get('guests')),
        rooms: positiveInteger(params.get('rooms')),
        children_ages: children ? children.split(',').map(Number).filter((age) => Number.isInteger(age) && age >= 0) : [],
        ...(params.has('private_travel') && { private_travel: params.get('private_travel') === 'true' }),
    };
};

const hasCompleteTrip = (search) => {
    const checkIn = parseDate(search?.check_in);
    const checkOut = parseDate(search?.check_out);
    return !!(checkIn && checkOut && checkOut > checkIn
        && positiveInteger(search?.guests) && positiveInteger(search?.rooms));
};

export const getPageViewContext = ({ location, isReservationFlow, storedSearch, place, profileReady = true }) => {
    if (!isReservationFlow) {
        return { ready: profileReady };
    }

    const root = location.pathname.split('/').filter(Boolean)[0];
    const destinations = [storedSearch?.destination, place ? { address: place.address, place } : undefined].filter(Boolean);
    const destination = destinations[0];
    const destinationPlace = destination?.place || destination;
    if (root === 'results' || root === 'hotel') {
        const params = new URLSearchParams(location.search);
        const pathHotelId = root === 'hotel' ? location.pathname.split('/').filter(Boolean)[2] : undefined;
        const hotelId = params.get('hotel_id') || pathHotelId;
        const placeId = params.get('place_id');
        const matchingDestination = destinations.find((candidate) => {
            const candidatePlace = candidate.place || candidate;
            return hotelId
                ? [candidatePlace.hotel_id, candidatePlace._id, candidatePlace.id].some((id) => id && String(id) === hotelId)
                : !!placeId && candidatePlace.place_id === placeId;
        });
        return {
            ready: profileReady && !!matchingDestination,
            search: parseUrlSearch(location.search),
            destination: matchingDestination,
        };
    }

    return {
        ready: profileReady && hasCompleteTrip(storedSearch) && !!destinationPlace,
        search: hasCompleteTrip(storedSearch) ? storedSearch : undefined,
        destination: hasCompleteTrip(storedSearch) ? destination : undefined,
    };
};

export const createPageViewController = (readContext, emit) => {
    let finished = false;
    let timer;
    const update = (timedOut = false) => {
        if (finished) {
            return;
        }
        const context = readContext();
        if (!context.ready && !timedOut) {
            return;
        }
        finished = true;
        clearTimeout(timer);
        emit(context);
    };
    timer = setTimeout(() => update(true), PAGE_CONTEXT_WAIT_MS);
    update();
    return {
        update: () => update(),
        dispose: () => {
            finished = true;
            clearTimeout(timer);
        },
    };
};
